import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { Nav, NavItem } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { string, array, bool, node, object, func, oneOfType } from 'prop-types';
import Card from './Card';
import { isString } from '../../utils/utils';

const propTypes = {
  title: oneOfType([string, node]).isRequired,
  controls: array.isRequired,
  statisticsControls: array.isRequired,
  children: node.isRequired,
  defaultMessage: string,
  loading: bool,
  tabs: bool,
  innerRef: oneOfType([object, func, string]),
};

const defaultProps = {
  title: '',
  controls: [],
  statisticsControls: [],
  tabs: false,
  loading: false,
};

const CardWithControls = ({
  title,
  controls,
  statisticsControls,
  children,
  tabs,
  defaultMessage,
  innerRef,
  hint,
  titleRoute,
  blankTitleRoute,
  titleLG,
  ...attributes
}) => {
  const classes = cn('card-with-controls-header-container no-padding', {
    'with-collapsing-btn': attributes.collapsing,
    'title-lg': titleLG,
  });

  const renderTitleRoute = (title) =>
    blankTitleRoute ? (
      <a href={titleRoute} target="_blank">
        {title}
      </a>
    ) : (
      <Link to={titleRoute}>{title}</Link>
    );
  const renderTitle = (title) => (titleRoute ? renderTitleRoute(title) : title);
  return (
    <Card {...attributes}>
      <Card.Header className={classes} innerRef={innerRef}>
        <div className="card-with-controls-header-text">
          {title &&
            renderTitle(
              isString(title) ? (
                <div>
                  <FormattedMessage id={title} defaultMessage={defaultMessage} />
                </div>
              ) : (
                <div>title</div>
              ),
            )}
          {hint && hint}

          {/* feature/OFFERRUM-2362 */}
          {statisticsControls.length > 0 && (
            <div className="card-with-controls-controls themed-card-controls">
              <Nav pills tabs={tabs}>
                {statisticsControls.map((control, index) => (
                  <NavItem key={index}> {control} </NavItem>
                ))}
              </Nav>
            </div>
          )}
        </div>

        {controls.length > 0 && (
          <div className="card-with-controls-controls themed-card-controls">
            <Nav pills tabs={tabs}>
              {controls.map((control, index) => (
                <NavItem key={index}> {control} </NavItem>
              ))}
            </Nav>
          </div>
        )}
      </Card.Header>
      {children}
    </Card>
  );
};

CardWithControls.propTypes = propTypes;
CardWithControls.defaultProps = defaultProps;

export default CardWithControls;
